import React from 'react';
import classes from './NotificationNumber.module.scss';

function NotificationNumber({notificationNumber}) {
    const notificationClass =
        notificationNumber <= 9 ? classes.small :
            notificationNumber <= 99 ? classes.medium :
                classes.large;
    return (
        notificationNumber > 0 ? <p className={`${classes.notificationNumber} ${classes,notificationClass}`}>{notificationNumber > 99 ? '99+' : notificationNumber}</p> : null
    );
}

export default NotificationNumber;